import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';

import { IconComponent } from '@ui-kit/components/base/icon/icon.component';

@Component({
  selector: 'app-errors-404',
  template: `
    <div class="flex h-screen w-screen items-center justify-center text-center tracking-tight">
      <div class="flex flex-col items-center gap-6">
        <div class="flex shrink items-center justify-center rounded-md border border-slate-200 p-1 shadow">
          <app-icon icon="tabler-world-question" iconClass="!size-8 text-primary" />
        </div>
        <span class="text-xs text-primary">Błąd 404</span>
        <span class="text-2xl font-semibold text-section-title"> Strona nie została znaleziona </span>
        <span class="font-semibold text-caret"> Wygląda na to, że strona, której szukasz, nie istnieje. </span>
        <span class="text-caret"> Sprawdź adres lub wróć do panelu, aby kontynuować </span>
        <div class="flex items-center">
          <button class="w-full font-bold" mat-flat-button [routerLink]="['/auth/sign-in']">
            <span class="tracking-tight">Wróć do panelu</span>
          </button>
        </div>
      </div>
    </div>
  `,
  imports: [IconComponent, MatButton, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Error404Component {}
